import React from 'react';

const LoadingSpinner = () => {
  return (
    <div id='loading-spinner-php' class='ccare__loading-spinner'>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default LoadingSpinner;
